import { AdBreakFilter, ListResult, SearchableFilter } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

import { AdBreak } from 'common/api/v1/types'
import { AdBreaksRequestParams, EnrichedAdBreak, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export class AdBreaksApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async listAdBreaks(params: AdBreaksRequestParams): Promise<ListResult<EnrichedAdBreak>> {
    let inputId: string | undefined
    if (params.inputName) {
      const inputs = await this.edgeClient.listInputs({ filter: { searchName: params.inputName } })
      inputId = inputs.items.find((i) => i.name === params.inputName)?.id
    }

    let adServerId: string | undefined
    if (params.adServerName) {
      if (params.adServerName === 'Edge Ad Server') {
        adServerId = 'edge-built-in'
      } else {
        const servers = await this.edgeClient.listExternalAdServers({ filter: { searchName: params.adServerName } })
        adServerId = servers.items.find((s) => s.name === params.adServerName)?.id
      }
    }

    const filter = {
      searchName: params.filter,
      fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
      toDate: params.toDate ? new Date(params.toDate) : undefined,
      status: params.status,
      adId: params.adId,
      eventId: params.eventId,
      inputId,
      programName: params.programName,
      programNumber: params.programNumber ? Number(params.programNumber) : undefined,
      adServerId,
    } as AdBreakFilter

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter,
      paginatedRequestParams: params,
    })
    const { total, items } = await this.edgeClient.listAdBreaks(query)

    const inputIds = Array.from(new Set(items.filter((ab) => ab.inputId).map((ab) => ab.inputId)))
    const inputs = inputIds.length > 0 ? (await this.edgeClient.listInputs({ filter: { ids: inputIds } })).items : []

    return {
      items: items.map((ab) => {
        const input = inputs.find(({ id }) => id === ab.inputId)
        return { ...ab, _inputName: input?.name }
      }),
      total,
    }
  }

  getAdBreak(id: string): Promise<AdBreak> {
    return this.edgeClient.getAdBreak(id)
  }

  deleteAdBreak(id: string): Promise<AdBreak> {
    return this.edgeClient.deleteAdBreak(id)
  }
}
